<template>
  <div id="CreateBusinessUnitForm">
    <div class="modal-card fixed-width dtac-font">
      <!-- Modal Title -->
      <header class="modal-card-head">
        <p v-if="isEditMode" class="modal-card-title">UPDATE BU INFO.</p>
        <p v-else class="modal-card-title">CREATE NEW BU</p>
      </header>
      <!-- Modal Description + Input -->
      <section class="modal-card-body">
        <div class="columns is-multiline">
          <div class="column is-12">
            <b-field label="Business Unit Name">
              <b-input required v-model="bu_name" />
            </b-field>
          </div>
          <div class="column is-12">
            <b-field label="Business Unit Code">
              <b-input required v-model="bu_code" :disabled="isEditMode" />
            </b-field>
          </div>
        </div>
      </section>
      <!-- Modal Footer -->
      <footer class="modal-card-foot" style="justify-content: flex-end">
        <!-- Button: Create + Save -->
        <button
          class="button is-primary"
          :disabled="isDisableButtonAction"
          @click.prevent="performButtonAction()"
        >
          {{ isEditMode ? "Update" : "Create" }}
        </button>
      </footer>
    </div>
  </div>
</template>

<script>
import BusinessUnitApi from "@/services/BusinessUnitApi";

import AlertManager from "@/utils/AlertManager";

export default {
  name: "CreateBusinessUnitForm",
  props: ["mode", "selected_unit"],
  data() {
    return {
      bu_name: null,
      bu_code: null
    };
  },
  computed: {
    manager_list: function() {
      if (this.selected_unit) {
        return this.selected_unit.managerList;
      } else {
        return [];
      }
    },
    isEditMode: function() {
      switch (this.mode) {
        case "edit":
          return true;
        default:
          return false;
      }
    },
    isDisableButtonAction: function() {
      if (
        this.bu_name &&
        this.bu_name !== "" &&
        this.bu_code &&
        this.bu_code !== ""
      ) {
        return false;
      } else {
        return true;
      }
    }
  },
  methods: {
    performButtonAction: function() {
      if (this.isEditMode) {
        const update_params = {
          business_unit_name: this.bu_name
        };
        this.requestUpdateBU(this.selected_unit._id, update_params);
      } else {
        const create_params = {
          _id: null,
          business_unit_name: this.bu_name,
          business_unit_code: this.bu_code
        };
        this.requestCreateBU(create_params);
      }
    },
    requestCreateBU: async function(params) {
      const loadingComponent = this.$buefy.loading.open({
        container: null
      });
      const response = await BusinessUnitApi.requestCreateBusinessUnit(params);
      loadingComponent.close();

      if (response.status) {
        this.$emit("close");
        this.$emit("create_success");
        AlertManager.showSuccessSnackbar(response.message);
      } else {
        AlertManager.showErrorSnackbar(response.message);
      }
    },
    requestUpdateBU: async function(bu_id, params) {
      const loadingComponent = this.$buefy.loading.open({
        container: null
      });
      const response = await BusinessUnitApi.requestUpdateBusinessUnit(
        bu_id,
        params
      );
      loadingComponent.close();

      if (response.status) {
        this.$emit("close");
        this.$emit("update_success");
        AlertManager.showSuccessSnackbar(response.message);
      } else {
        AlertManager.showErrorSnackbar(response.message);
      }
    }
  },
  async beforeMount() {
    if (this.isEditMode) {
      this.bu_name = this.selected_unit.business_unit_name;
      this.bu_code = this.selected_unit.business_unit_code;
    }
  }
};
</script>

<style scoped>
.fixed-width {
  max-width: 480px;
  padding: 0 20px;
}
.column {
  padding: 0.5rem;
}
</style>
